import { FC, useContext } from 'react';
import MultiFactorAuthProvider, {
    MultiFactorAuthContext,
    EMultiFactorAuthUiState,
} from '../../contexts/MultiFactorAuthContext';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ERoutes } from '../../util/constants';
import { Loader } from '../../components/Loader/Loader';
import MultiFactorAuthVerify from '../../components/MultiFactorAuthVerify/MultiFactorAuthVerify';
import MultiFactorAuthRecovery from '../../components/MultiFactorAuthRecovery/MultiFactorAuthRecovery';
import MultiFactorAuthDisabledSuccess from '../../components/MultiFactorAuthDisabledSuccess/MultiFactorAuthDisabledSuccess';
import PageLayoutV2 from '../../layout/PageLayoutV2/PageLayoutV2';
import { Stack } from '@mui/material';
import MultiFactorAuthExpired from '../../components/MultiFactorAuthExpired/MultiFactorAuthExpired';

const MultiFactorAuthRouter: FC = () => {
    return (
        <Switch>
            <Route exact path={ERoutes.multiFactorAuthValidate}>
                <MultiFactorAuthVerify />
            </Route>
            <Route exact path={ERoutes.multiFactorAuthRecovery}>
                <MultiFactorAuthRecovery />
            </Route>
            <Route exact path={ERoutes.multiFactorAuthDisable}>
                <MultiFactorAuthDisabledSuccess />
            </Route>
        </Switch>
    );
};

const MultiFactorAuthUi: FC = () => {
    const { multiFactorAuthUiState, redirectUrl } = useContext(MultiFactorAuthContext);
    switch (multiFactorAuthUiState) {
        case EMultiFactorAuthUiState.default:
        case EMultiFactorAuthUiState.routerStateParsed:
            return (
                <PageLayoutV2>
                    <Stack direction={'row'} sx={{ justifyContent: 'center' }}>
                        <Loader />
                    </Stack>
                </PageLayoutV2>
            );
        case EMultiFactorAuthUiState.ready:
        case EMultiFactorAuthUiState.loading:
        case EMultiFactorAuthUiState.error:
        case EMultiFactorAuthUiState.disabled:
            return <MultiFactorAuthRouter />;
        case EMultiFactorAuthUiState.expired:
            return <MultiFactorAuthExpired />;
        case EMultiFactorAuthUiState.success:
            return (
                <>
                    <PageLayoutV2>
                        <Stack direction={'row'} sx={{ justifyContent: 'center' }}>
                            <Loader />
                        </Stack>
                    </PageLayoutV2>
                    {window.location.assign(redirectUrl)}
                </>
            );
        case EMultiFactorAuthUiState.fatalError:
            return <Redirect to={ERoutes.error} />;
        default:
            console.error('Invalid multi factor auth ui state');
            return <Redirect to={ERoutes.error} />;
    }
};

const MultiFactorAuthScreen: FC = () => {
    return (
        <MultiFactorAuthProvider>
            <MultiFactorAuthUi />
        </MultiFactorAuthProvider>
    );
};

export default MultiFactorAuthScreen;
